export var VERSION = '2.35.4';
//# sourceMappingURL=version.js.map